export default __webpack_public_path__ + "static/media/rank-1.42b65909.svg";